import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[appRemoveFocus]',
  standalone: true,
})
export class FocusRemoveDirective {
  constructor(private elementRef: ElementRef) {}

  @HostListener('click') onClick(): void {
    this.elementRef.nativeElement.blur();
  }

  @HostListener('document:keydown.escape')
  onEscapePress() {
    this.elementRef.nativeElement.blur();
  }
}
